
import Vue from 'vue';
import _ from 'lodash';
import { common, baseComponents } from '@tencent/ceiba-base-components';
import { saveRoleToCookie } from '@tencent/upweb-utils';

/**
 * 获取组合内的所有组合和组件信息
 */
const getGroupsItems = (groupId, components = [], groups = []) => {
  if (!groupId) {
    return {};
  }
  const group = groups.find(item => item.id === groupId);
  if (!group) {
    return {};
  }
  const groupStack = [];
  groupStack.push(_.cloneDeep(group));
  const allComponents = [];
  const allGroups = [];
  // 组件映射
  const componentMap = components.reduce((acc, item, index) => {
    acc[item.id] = _.cloneDeep(item);
    acc[item.id].index = index;
    return acc;
  }, {});

  // 组合映射
  const groupMap = groups.reduce((acc, item, index) => {
    acc[item.id] = _.cloneDeep(item);
    acc[item.id].index = index;
    return acc;
  }, {});

  // 递归查找
  do {
    const currentGroup = groupStack.pop();
    if (currentGroup.components.length) {
      currentGroup.components.forEach((id) => {
        allComponents.push(_.cloneDeep(componentMap[id]));
      });
    }
    if (currentGroup.groups.length) {
      currentGroup.groups.forEach((id) => {
        const item = _.cloneDeep(groupMap[id]);
        allGroups.push(item);
        groupStack.push(item);
      });
    }
  } while (groupStack.length);

  return {
    components: allComponents,
    groups: allGroups,
  };
};

function getStateText(ctx, stateText) {
  console.log('ctx=', ctx);
  if (!stateText) return '';

  console.log('stateText=', stateText);
  // 匹配模式 支持多层传值匹配 比如 xxxx.xxxx.xxx
  const text = stateText.replaceAll(/{{\s?([A-Za-z0-9_\\.]+)\s?}}/g, (_r, match) => getFields(ctx, match.split('.')));
  console.log('template text=', text);
  return text;
}

function getFields(object, querys) {
  console.log('getFields=', object, querys);
  if (querys.length > 1) {
    const key = querys.shift();
    return getFields(object[key], querys);
  }
  let field = '';
  if (querys[0] in object) {
    field = object[querys[0]];
  }
  return field;
}
function getUrlInfo() {
  let search = location.search.substring(1);

  if (search) {
    if (search[search.length - 1] === '&') search = search.substring(0, search.length - 1);
    const arrs = search.split('&');
    const obj = {};
    arrs.forEach((value) => {
      const kv = value.split('=');
      if (kv.length === 2) {
        const [key, val] = kv;
        obj[key] = val;
      }
    });
    return obj;
    // return JSON.parse(`{"${decodeURI(search).replace(/"/g, '\\"')
    //   .replace(/&/g, '","')
    //   .replace(/=/g, '":"')}"}`);
  }
  return {};
}

/**
 * 处理登录态参数 拼接到url上
 */
function getLoginStatusUrl(url, type) {
  let newLink = url;
  const accType = common.tool.getCookie('acctype') || '';
  const openId = common.tool.getCookie('openid') || '';
  const appId = common.tool.getCookie('appid') || '';
  const accessToken = common.tool.getCookie('access_token') || '';
  const referrer = window?.location?.href ?? '';
  // 携带源地址参数
  const sourceParams = window.location.search.substr(1);
  let params = {};
  switch (type) {
    // 拼接from源地址到url上
    case 'isSourceAddressFlag':
      params = {
        from: referrer,
      };
      break;
      // 无忧充值
    case 'worryFreeChargeTokenFlag':
      params = {
        appid: appId,
        openid: openId,
        acctype: accType,
        access_token: accessToken,
      };
      break;
    case 'isSourceParamsFlag':
      newLink = `${newLink}${newLink.includes('?') ? '&' : '?'}${sourceParams}`;
      return newLink;
      break;
    default:
      break;
  }
  console.log('getLoginStatusUrl params=', params);
  Object.keys(params).forEach((key) => {
    newLink = common.tool.setUrlParam(`${key}`, `${params[key]}`, newLink);
  });
  return newLink;
}

/**
 *  元素点击事件相关方法
 * */
export default {
  data() {
    return {
      ComponentZIndexMax: 100, // 组件置顶事件触发可设置的最高值
    };
  },
  methods: {
    /**
     * 链接跳转
     */
    _event_redirectURL(eventData) {
      const openUrl = Vue.prototype.$opener?.openView;
      return new Promise(async (resolve) => {
        console.log('eventData=', eventData);
        if (eventData.page === 'http://back' || eventData.page === 'https://back') {
          window.history.go(-1);
          resolve();
          return;
        }
        // 游戏内关闭活动页面
        if (eventData.page === 'http://gameInClosePage' || eventData.page === 'https://gameInClosePage') {
          try {
            common.gameMsdk.msdkCall('{"MsdkMethod":"closeWebView"}');
            resolve();
          } catch (error) {
            console.log('http://gameInClosePage fail', error);
          }
          return;
        }
        if (eventData.page === 'http://msdkCloseWebview' || eventData.page === 'https://msdkCloseWebview') {
          try {
            common.gameMsdk.msdkCloseWebview();
            resolve();
          } catch (error) {
            console.log('http://msdkCloseWebview fail', error);
          }
          return;
        }
        if (eventData.link === 'outer') {
          if (!openUrl) {
            console.log('not found openUrl', openUrl);
            resolve();
          }
          let url = eventData.page;
          const urlInfo = getUrlInfo();
          console.log('getUrlInfo=', urlInfo);
          url = getStateText(Object.assign(this.$store, {
            urlInfo,
            location: {
              search: location.search,
            },
            loginState: {
              openid: this.$store?.getters?.userAuth?.['T-OPENID'] || '',
              appid: this.$store?.getters?.userAuth?.['T-APPID'] || '',
              access_token: this.$store?.getters?.userAuth?.['T-ACCESS-TOKEN'] || '',
              account_type: this.$store?.getters?.userAuth?.['T-ACCOUNT-TYPE'] || '',
            },
          }), url);

          console.log('openUrl =', url);

          // 需要携带源地址
          if (eventData?.isSourceParamsFlag) {
            url = getLoginStatusUrl(url, 'isSourceParamsFlag');
          }

          // 需要携带源地址
          if (eventData?.isSourceAddressFlag) {
            url = getLoginStatusUrl(url, 'isSourceAddressFlag');
          }

          // 声明 CEIBA 可以同步登录态的白名单域名
          const DOMAIN_WHITE_LIST = [
            'xinyue.qq.com',
            'supercore.qq.com',
            'shanxian.qq.com',
            'gbot.qq.com',
            'youxi.qq.com',
            'gp.qq.com', // 和平
            'ceiba.qq.com',
            'jihuang.qq.com', // 饥荒
            'vipzx.qq.com', // 尊享商城
          ];

          // 需要跳其他ceiba活动且有角色 同步角色信息到跳转的域名
          if (
            eventData?.targetRoleInfo === 'ceibaRoleInfo' && this.$store?.state?.roleInfo?.role_id
          ) {
            const domain = url.split('//')[1]?.split('/')[0];
            const containsTargetDomain = DOMAIN_WHITE_LIST.some(target => domain.includes(target));
            if (containsTargetDomain) {
              // 只有目标域名是 ceiba 的白名单域名才进行同步
              const ceibaRoleInfo = JSON.stringify(this.roleInfo);
              const ceibaRoleKey = `ceiba_role_info_${this.currentGid}`;
              await new Promise((resolve) => {
                try {
                  Vue.prototype.$miloCore?.loginStatus?.syncToQQ(domain, {
                    [ceibaRoleKey]: ceibaRoleInfo,
                  }, () => {
                    resolve();
                  });
                } catch (err) {
                  console.error('syncCeibaRoleInfo error ==', err);
                }
              });
            }
          }

          // 各个业务 是否登录 后才可以进行跳转
          if (eventData?.checkLoginFlag) {
            if (this.$store.state.isLogin) {
              // 截取一级域名
              const domain = url.split('//')[1]?.split('/')[0];
              const containsTargetDomain = DOMAIN_WHITE_LIST.some(target => domain.includes(target));
              if (containsTargetDomain) {
                // 只有目标域名是 ceiba 的白名单域名才进行同步
                // 超核无忧充值登录态
                if (eventData?.worryFreeChargeTokenFlag) {
                  url = getLoginStatusUrl(url, 'worryFreeChargeTokenFlag');
                }
                // 需要携带登录态 将登录态cookies信息种植到对应跳转链接 的一级域名下
                if (eventData?.isLoginStatusFlag) {
                  await new Promise((resolve) => {
                    try {
                      Vue.prototype.$miloCore?.loginStatus?.syncToQQ(domain, {
                        appid: this.$store?.getters?.userAuth?.['T-APPID'] || '',
                        openid: this.$store?.getters?.userAuth?.['T-OPENID'] || '',
                        access_token: this.$store?.getters?.userAuth?.['T-ACCESS-TOKEN'] || '',
                        acctype: this.$store?.getters?.userAuth?.['T-ACCOUNT-TYPE'] || '',
                      }, () => {
                        console.log('sync login status');
                        resolve();
                      });
                    } catch (err) {
                      console.log('syncToQQ==', err);
                    }
                  });
                }
                // 大商城且有角色 同步角色信息到跳转的域名
                if (
                  eventData?.targetRoleInfo === 'bigMallRoleInfo' && this.$store?.state?.roleInfo?.role_id
                ) {
                  const loginStatus = Vue.prototype.$miloCore?.loginStatus || window.milo.loginStatus;
                  await new Promise((resolve) => {
                    saveRoleToCookie(this.$store?.getters?.currentGid, this.$store?.state?.roleInfo, {
                      loginStatus, // milo loginStatus结构体
                      handler: loginStatus.syncToQQ,
                      domain, // 需要同步的域名
                    }).then((key) => {
                      console.log(key);
                      console.log(document.cookie);
                      url = `${url}${url.includes('?') ? '&' : '?'}upRoleKey=${key}`;
                      console.log('saveRoleToCookie success', key, url);
                      resolve();
                    })
                      .catch((e) => {
                        console.log('saveRoleToCookie error', e);
                        resolve();
                      });
                  });
                }
              }
            } else {
              baseComponents.userLoginComponent.login();
              return;
            }
          }

          console.info('redierectUrl', url);
          openUrl(Object.assign(eventData, { url }), this.$store.state);
        } else {
          const linkedId = eventData.page;
          if (!this.actInfo.config.configs[linkedId]) {
            this.$message({
              type: 'error',
              content: '查看失败，请联系管理员开通权限',
            });
            return;
          }
          if (eventData.target === '_self') {
            this.updatePageId(eventData.page);
          } else {
            const { href } = this.$router.resolve({
              path: '',
              query: {
                previewUid: this.$route.query.previewUid,
                pageId: eventData.page,
              },
            });
            window.open(href, eventData.target);
          }
        }
        resolve();
      });
    },
    _event_display(eventData, _refs) {
      const { componentConfig = [] } = this.pageInfo;
      const { componentId: targetComponentId } = eventData;
      const getComponents = (id) => {
        const { components } = getGroupsItems(id);
        if (components?.length) {
          return components;
        }
        return [common.tool.findComponentById(componentConfig, id)];
      };

      const show = (component) => {
        // const $el = _refs[component.id]?.[0]?.$el;
        Vue.set(component.styles.base, 'display', 'block');
        Vue.set(component.styles.base, 'displayVal', 'block');
      };

      const hide = (component) => {
        // const $el = _refs[component.id]?.[0]?.$el;
        Vue.set(component.styles.base, 'display', 'none');
        Vue.set(component.styles.base, 'displayVal', 'none');
      };
      const targetComponentIds = 'string' === typeof targetComponentId ? [targetComponentId] : targetComponentId;
      targetComponentIds.forEach((id) => {
        getComponents(id).forEach((item) => {
          const component = common.tool.findComponentById(this.pageInfo.componentConfig, item?.id || '');
          if (!component) {
            return;
          }
          switch (eventData.displayMode) {
            case 'show':
              show(component);
              break;
            case 'hide':
              hide(component);
              break;
            case 'switch':
              component.styles.base.display === 'none' ? show(component) : hide(component);
              break;
            default:
              break;
          }
          if (component.styles.base.display === 'block' && eventData.showTop) {
            // 当组件的z-index小于当前z-index最高值，才会更新this.ComponentZIndexMax
            if (this.ComponentZIndexMax > component.styles.base['z-index']) {
              this.ComponentZIndexMax += 1;
            }
            Vue.set(component.styles.base, 'z-index', this.ComponentZIndexMax);
          }
        });
      });
    },
    _event_changeDynamicStatus(eventData, refs) {
      const { targetComponentId, targetStatus, animation } = eventData;
      refs[targetComponentId]?.[0]?.setTempStatus?.({
        status: targetStatus,
        topAll: eventData.topAll,
        animation,
      });
    },
    _event_scrollToElement(eventData) {
      const { componentId } = eventData;
      console.log('_event_scrollToElement=', eventData, this.$refs);
      const targetComponentId = 'string' === typeof componentId ? componentId : componentId[0];
      const el = document.getElementById(targetComponentId);
      return el?.scrollIntoView();
    },
    _event_scrollToTop() {
      return window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    _event_copyText(eventData) {
      const { content } = eventData;
      try {
        // if (navigator.clipboard) {
        //   console.log('navigator.clipboard')
        //   // clipboard api 复制
        //   navigator.clipboard.writeText(content);
        // } else {
        console.log('fake copy test');
        const isRTL = document.documentElement?.getAttribute('dir') === 'rtl';

        const textarea = document.createElement('textarea');
        // Prevent zooming on iOS
        textarea.style.fontSize = '12pt';
        // Reset box model
        textarea.style.border = '0';
        textarea.style.padding = '0';
        textarea.style.margin = '0';
        // Move element out of screen horizontally
        textarea.style.position = 'absolute';
        textarea.style[isRTL ? 'right' : 'left'] = '-9999px';
        // Move element to the same position vertically
        const yPosition = window.pageYOffset || document.documentElement?.scrollTop;
        textarea.style.top = `${yPosition}px`;

        textarea.setAttribute('readonly', '');

        // 赋值
        textarea.value = getStateText(Object.assign(this.$store, {
          urlInfo: getUrlInfo(),
        }), content);
        document.body.appendChild(textarea);
        // 选中
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        console.log('select textarea=', textarea);
        // 复制
        let succeeded;
        try {
          succeeded = document.execCommand('copy');
        } catch (err) {
          succeeded = false;
        }
        // 移除输入框
        document.body.removeChild(textarea);
        // }
        Vue.prototype.toast(`复制${succeeded ? '成功' : '失败'}`);
      } catch (e) {
        console.error('copyText fail, err=', e);
      }
    },
    /**
     * 调用流程
     */
    async _event_flowRunner(eventData) {
      const { flowId, forceRole } = eventData;
      try {
        if (forceRole && this.isRoleStatusValid && !this.isRoleReady) {
          this.alert({
            msg: '未检测到角色，请先绑定角色',
            confirm: () => { },
          });
          return;
        }
        const response = await this.flowRequest({
          flowId,
        });
        console.log('_event_flowRunner response=', response);
        if (response.ret || response.data.ret) {
          this.alert(response.data.msg || response.msg);
          return false;
        }
        return true;
      } catch (e) {
        console.error('_event_flowRunner fail, ', e);
      }
    },
    _event_refresh(eventData, refs) {
      // 根据id 遍历找到组件，执行组件的刷新方法

      eventData.data.forEach((eachEvt) => {
        const { ids: componentIds } = eachEvt;
        componentIds.forEach((id) => {
          const [component] = refs[id];
          if (component) {
            const { date } = eventData;
            const [beginTime, endTime] = date.map(e => e.getTime());
            component.refreshData?.({ beginTime, endTime });
          }
        });
      });
    },

    _event_componentAction({ method, from, to }, args) {
      // vue组件动作
      const [component] = this.$refs[to];
      if (component) {
        console.log(`call ceiba:component:events|from=${from}|to=${to}|method=${method}|component=`, component);
        component[method]?.(...args);
      }
    },

    _event_customEmit(eventData) {
      console.log(eventData, '_event_customEmit');
      const { emitValue } = eventData;
      if (emitValue) {
        console.log(Vue.prototype.$eventBus.$emit);
        Vue.prototype.$eventBus.$emit(emitValue, {});
      }
    },

    /**
   * 刷新活动页面
   */
    _event_refreshActivityPageEvent() {
      console.log('refreshActivityPageEvent');
      window?.location?.reload();
    },
  },
};
